__turbopack_context__.v({
  "button": "aM4KzG_button",
  "header": "aM4KzG_header",
  "icon": "aM4KzG_icon",
  "question": "aM4KzG_question",
  "specificity": "aM4KzG_specificity",
});
